import { planCategoryLabel } from '~/pages/AdminOcctoMaster/tabs/GenerationSalesPlanMaster/models/planCategory'
import type { GenerationSalesMasterRow } from '~/pages/AdminOcctoMaster/tabs/GenerationSalesPlanMaster/types'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

/**
 * 発電販売計画マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 * List レスポンスのフィールドのみを対象とし (AC-04)、詳細モーダルでのみ
 * 見える取引相手コード / 所属 BG / 所属発電所の各リスト明細は含まない
 * (件数のみを出力する)。
 * 計画区分列は generation-sales-plan-category 設計書 AC-07 で追加
 * (「通常電源」「FIT特例電源」の表示名で出力する)。
 */
export function generationSalesPlanMasterCsvColumns(): Array<
  CsvColumnDef<GenerationSalesMasterRow>
> {
  return [
    {
      headerKey:
        'page:adminOcctoMaster.generationSalesPlanMaster.column.submitterCode',
      accessor: (row) => row.submitterCode,
    },
    {
      headerKey:
        'page:adminOcctoMaster.generationSalesPlanMaster.column.planCategory',
      accessor: (row) => planCategoryLabel(row.planCategory),
    },
    {
      headerKey: 'page:adminOcctoMaster.generationSalesPlanMaster.column.note',
      accessor: (row) => row.note ?? '',
    },
    {
      headerKey:
        'page:adminOcctoMaster.generationSalesPlanMaster.column.codeCount',
      accessor: (row) => String(row.codeCount),
    },
    {
      headerKey:
        'page:adminOcctoMaster.generationSalesPlanMaster.column.bgCount',
      accessor: (row) => String(row.bgCount),
    },
    {
      headerKey:
        'page:adminOcctoMaster.generationSalesPlanMaster.column.plantCount',
      accessor: (row) => String(row.plantCount),
    },
  ]
}
